import { makeStyles, Snackbar } from '@material-ui/core';
import LoopIcon from '@material-ui/icons/Loop';
import React from 'react';

import Colors from 'src/nightingale/Colors';

const useStyles = makeStyles({
  root: {
    pointerEvents: 'none',

    '& *': {
      pointerEvents: 'auto',
    },
  },
  button: {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    color: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    fontFamily: '"Nunito", "Nunito Sans"',
    fontSize: 14,
    fontWeight: 'bold',
    justifyContent: 'center',
    letterSpacing: 1.12,
    padding: 0,
    textTransform: 'uppercase',
  },
  cancelButton: {
    marginRight: '22px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 4,
  },
  snackbarContents: {
    cursor: 'pointer',
    width: 600,
    marginTop: 60,
    backgroundColor: Colors.BlueSpruce,
  },
});

export const SnapshotSnackbar: React.FC<{
  onAccept: () => void;
  onDismiss: () => void;
  updatedPropertyLabels: string[];
}> = ({ onAccept, onDismiss, updatedPropertyLabels }) => {
  const styles = useStyles();

  return (
    <Snackbar
      action={
        <>
          <button
            className={`${styles.button} ${styles.cancelButton}`}
            data-testid="snapshot-snackbar-dismiss"
            type="button"
            onClick={onDismiss}
          >
            Dismiss
          </button>
          <button
            className={styles.button}
            data-testid="snapshot-snackbar-cta"
            type="button"
            onClick={onAccept}
          >
            Load new data
            <LoopIcon classes={{ root: styles.iconContainer }} />
          </button>
        </>
      }
      ContentProps={{ className: styles.snackbarContents }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      classes={{ root: styles.root }}
      data-testid="snapshot-snackbar"
      message={
        <>
          This patient&apos;s information has been updated:
          <ul>
            {updatedPropertyLabels.sort().map(label => (
              <li>{label}</li>
            ))}
          </ul>
        </>
      }
      open
    />
  );
};
